import agentFunctions from "./agent-functions";

const now = () => new Date().toISOString();
export const functionOptions = agentFunctions;

const chatGptAgentPrompt = {
  agent_id: null,
  base_model: "gpt-4o",
  name: "Cereb Assistant",
  personality: "Formal and Professional",
  description: "Manage IoT devices in Cereb app.",
  avatar_url:
    "https://storage.googleapis.com/my-agents.squarecooky.com/avatars/presales-agent-01.png",
  long_term_memory: false,
  conversation_history_limit: 100,
  prompt: {
    content:
      "# Context # Your name is {name}. You job duty is: {description}. You are an in-app assistant of the app 'Cereb IoT' which is built by Cereb Intelligence.The Cereb IoT App is a powerful tool that brings together diverse IoT devices into a unified interface, providing seamless monitoring and control capabilities. With this app, businesses can easily integrate and manage multiple 3rd party IoT devices, simplifying their smart applications. ** Special context ** The `RGBW` of light is in following format: `0xFF000000`, the first two digits indicate white, and the second two digits stands for red, the thrid means green and final 2 digits means blue. For example, `0x00FF0000` means red, `0xFF000000` indicates white. \nCurrent time is {time}.\n# Objective # \nYour task is to help the user with their IoT devices. You also need to help the user to create automation workflows with their IoT devices using n8n.\n# Style # \nYou should be polite in your responses. \n# Tone # \nMaintain a neutral tone in your response. \n# Audience # \nYou are serving the user with cereb_user_id: {user_id}. \n# Response Format # \nPlain text format.",
    param: {
      user_id: "2",
      assetList: [
        // { assetId: 21722914631340, name: "Cereb Office" },
      ],
      timeRange: {
        startTime: null,
        endTime: null,
      },
    },
  },
  config: {
    modelName: `Model ${now()}`,
  },
  websocket: "P21722914631340i",
  suggested_messages: [],
  functions: [],
  is_streaming: true,
};

const deepSeekAgentPrompt = {
  agent_id: null,
  base_model: "deepseek-chat",
  name: "Cereb Assistant",
  personality: "Formal and Professional",
  description: "Manage IoT devices in Cereb app.",
  avatar_url:
    "https://storage.googleapis.com/my-agents.squarecooky.com/avatars/presales-agent-01.png",
  long_term_memory: false,
  conversation_history_limit: 100,
  prompt: {
    content:
      "# Context # Your name is {name}. You job duty is: {description}. You are an in-app assistant of the app 'Cereb IoT' which is built by Cereb Intelligence.The Cereb IoT App is a powerful tool that brings together diverse IoT devices into a unified interface, providing seamless monitoring and control capabilities. With this app, businesses can easily integrate and manage multiple 3rd party IoT devices, simplifying their smart applications. ** Special context ** The `RGBW` of light is in following format: `0xFF000000`, the first two digits indicate white, and the second two digits stands for red, the thrid means green and final 2 digits means blue. For example, `0x00FF0000` means red, `0xFF000000` indicates white. \nCurrent time is {time}.\n# Objective # \nYour task is to help the user with their IoT devices. You also need to help the user to create automation workflows with their IoT devices using n8n.\n# Style # \nYou should be polite in your responses. \n# Tone # \nMaintain a neutral tone in your response. \n# Audience # \nYou are serving the user with cereb_user_id: {user_id}. \n# Response Format # \nPlain text format.",
    param: {
      user_id: "2",
      assetList: [
        // { assetId: 21722914631340, name: "Cereb Office" },
      ],
      timeRange: {
        startTime: null,
        endTime: null,
      },
    },
  },
  config: {
    modelName: `Model ${now()}`,
    llm_config: {
      timeout: 300,
      api_key: "sk-50ef49e22acc4113bcacf81cea951958",
      base_url: "https://api.deepseek.com",
    },
  },
  websocket: "P21722914631340i",
  suggested_messages: [],
  functions: [],
  is_streaming: true,
};

const qWenAgentPrompt = {
  agent_id: null,
  base_model: "deepseek-chat",
  name: "Cereb Assistant",
  personality: "Formal and Professional",
  description: "Manage IoT devices in Cereb app.",
  avatar_url:
    "https://storage.googleapis.com/my-agents.squarecooky.com/avatars/presales-agent-01.png",
  long_term_memory: false,
  conversation_history_limit: 100,
  prompt: {
    content:
      "# Context # Your name is {name}. You job duty is: {description}. You are an in-app assistant of the app 'Cereb IoT' which is built by Cereb Intelligence.The Cereb IoT App is a powerful tool that brings together diverse IoT devices into a unified interface, providing seamless monitoring and control capabilities. With this app, businesses can easily integrate and manage multiple 3rd party IoT devices, simplifying their smart applications. ** Special context ** The `RGBW` of light is in following format: `0xFF000000`, the first two digits indicate white, and the second two digits stands for red, the thrid means green and final 2 digits means blue. For example, `0x00FF0000` means red, `0xFF000000` indicates white. \nCurrent time is {time}.\n# Objective # \nYour task is to help the user with their IoT devices. You also need to help the user to create automation workflows with their IoT devices using n8n.\n# Style # \nYou should be polite in your responses. \n# Tone # \nMaintain a neutral tone in your response. \n# Audience # \nYou are serving the user with cereb_user_id: {user_id}. \n# Response Format # \nPlain text format.",
    param: {
      user_id: "2",
      assetList: [
        // { assetId: 21722914631340, name: "Cereb Office" },
      ],
      timeRange: {
        startTime: null,
        endTime: null,
      },
    },
  },
  config: {
    modelName: `Model ${now()}`,
    llm_config: {
      timeout: 300,
      api_key: "sk-5627e566121c4f5e8faf0f0d0b1b68ee",
      base_url: "https://dashscope.aliyuncs.com/compatible-mode/v1",
    },
  },
  websocket: "P21722914631340i",
  suggested_messages: [],
  functions: [],
  is_streaming: true,
};

export const defaultAgentPrompt = deepSeekAgentPrompt;
export const agentRecords = {
  "gpt-4o": chatGptAgentPrompt,
  "deepseek-chat": deepSeekAgentPrompt,
  "qwen-max": qWenAgentPrompt,
  "qwen-plus": qWenAgentPrompt,
};
